/**
 * CountdownTimer
 *
 * Displays a live, drift-corrected countdown.
 * Colour shifts: white → amber (≤60 s) → red + pulse (≤30 s)
 * Calls onExpire() once when time runs out.
 *
 * Props
 * ─────
 * totalSeconds : number | null   — null = no limit (shows "∞")
 * startedAt    : string | Date   — ISO timestamp when the attempt began
 * onExpire     : () => void      — callback fired once when time hits 0
 */

import { useTranslation } from 'react-i18next'
import { useCountdown }   from '@/hooks/useCountdown'

export default function CountdownTimer({ totalSeconds, startedAt, onExpire }) {
  const { t } = useTranslation()
  const { formatted, isWarning, isDanger, isExpired } = useCountdown(
    totalSeconds,
    startedAt,
    onExpire,
  )

  const timeClasses = [
    'font-mono font-bold text-sm tabular-nums tracking-wider',
    isDanger  ? 'text-red-500 animate-pulse-red' :
    isWarning ? 'text-amber-500'                 :
                'text-gray-800 dark:text-white',
  ].join(' ')

  return (
    <span
      className={timeClasses}
      aria-live="polite"
      aria-atomic="true"
      aria-label={`${t('exam.timeLeft')}: ${formatted}`}
    >
      {isExpired ? t('exam.timesUp') : formatted}
    </span>
  )
}

